import { ITokenResponse } from '@config/cognito';

export async function returnCognitoResponse(response: Response): Promise<ITokenResponse> {
  const json = await response.json();
  if (json.error) {
    throw new Error(json.error);
  }
  return json;
}
